var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSomething(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 684.316,
    height: 437.893,
    viewBox: "0 0 684.316 437.893",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(-670 -354.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "went"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(583.666 288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(110.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 139.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 153.564,
    height: 226.118,
    transform: "matrix(0.831, -0.556, 0.556, 0.831, 0, 85.376)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(122.511 147.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 22.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M280.27,280.765l-1.449,8.965-63.453-9.141,1.449-8.965Z",
    transform: "translate(-215.368 -271.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(22.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M245.55,251.547l9.105,1.312-10.1,62.474-9.105-1.312Z",
    transform: "translate(-235.455 -251.547)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(137.412 71.349)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M228.466,184.995",
    transform: "translate(-228.466 -184.995)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(39.544 67.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M199.9,181.745c.091.137-12.7,8.852-28.567,19.464s-28.808,19.109-28.9,18.973,12.7-8.849,28.57-19.465S199.812,181.61,199.9,181.745Z",
    transform: "translate(-142.436 -181.744)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(48.608 55.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M245.748,171.387c.091.137-21.181,14.524-47.506,32.13s-47.748,31.778-47.839,31.641,21.176-14.519,47.51-32.134S245.657,171.251,245.748,171.387Z",
    transform: "translate(-150.403 -171.386)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(58.018 69.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M254.019,183.753c.091.137-21.181,14.524-47.5,32.131s-47.748,31.776-47.839,31.641,21.176-14.52,47.509-32.134S253.928,183.618,254.019,183.753Z",
    transform: "translate(-158.675 -183.752)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(67.427 84.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M262.29,196.12c.091.135-21.18,14.523-47.5,32.13s-47.748,31.778-47.839,31.641,21.176-14.52,47.509-32.134S262.2,195.984,262.29,196.12Z",
    transform: "translate(-166.946 -196.119)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(76.836 98.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M270.562,208.486c.091.137-21.181,14.524-47.506,32.13s-47.748,31.778-47.839,31.641,21.176-14.519,47.51-32.132S270.471,208.351,270.562,208.486Z",
    transform: "translate(-175.217 -208.485)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(447.264 265.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 128.968,
    height: 189.9,
    transform: "translate(0 71.701) rotate(-33.777)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(102.889 123.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 19.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M645.792,366.108l-1.217,7.529-53.29-7.677,1.217-7.529Z",
    transform: "translate(-591.285 -358.431)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(19.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M616.633,341.569l7.647,1.1L615.8,395.139l-7.647-1.1Z",
    transform: "translate(-608.155 -341.569)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(115.402 59.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M602.285,285.678",
    transform: "translate(-602.285 -285.678)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(33.21 56.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M578.3,282.948c.091.137-10.64,7.473-23.966,16.386s-24.206,16.031-24.3,15.894,10.638-7.471,23.968-16.387S578.206,282.813,578.3,282.948Z",
    transform: "translate(-530.035 -282.946)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(40.822 46.919)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M616.8,274.249c.091.137-17.761,12.237-39.869,27.024s-40.113,26.67-40.2,26.534,17.758-12.234,39.874-27.027S616.708,274.114,616.8,274.249Z",
    transform: "translate(-536.726 -274.248)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(48.725 58.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M623.746,284.635c.091.135-17.762,12.236-39.87,27.023s-40.112,26.67-40.2,26.533,17.758-12.234,39.874-27.026S623.655,284.5,623.746,284.635Z",
    transform: "translate(-543.673 -284.634)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(56.627 70.548)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M630.692,295.02c.091.137-17.761,12.237-39.869,27.023s-40.113,26.67-40.2,26.534,17.758-12.234,39.874-27.026S630.6,294.885,630.692,295.02Z",
    transform: "translate(-550.619 -295.019)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(64.529 82.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M637.639,305.406c.091.137-17.762,12.236-39.87,27.023s-40.112,26.67-40.2,26.533,17.758-12.234,39.874-27.026S637.548,305.271,637.639,305.406Z",
    transform: "translate(-557.566 -305.405)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51",
    transform: "translate(175.793 83.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 132.643,
    height: 195.312,
    transform: "matrix(0.882, 0.472, -0.472, 0.882, 92.11, 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(56.606 128.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(14.08 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M350.6,238.666l-7.421,2.542-18.836-52.072,7.421-2.541Z",
    transform: "translate(-324.341 -186.594)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 14.715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M363.678,199.529l2.7,7.472-51.714,17.711-2.7-7.472Z",
    transform: "translate(-311.964 -199.529)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(158.676 99.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M401.689,160.379",
    transform: "translate(-401.689 -160.379)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(92.405 38.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M396.093,135.4c-.091.172-11.955-5.994-26.493-13.771s-26.257-14.221-26.166-14.392,11.953,5.994,26.5,13.772S396.185,135.229,396.093,135.4Z",
    transform: "translate(-343.434 -107.234)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(85.765 50.974)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M424.964,164.879c-.091.171-19.725-10.151-43.847-23.052s-43.612-23.5-43.52-23.673,19.72,10.148,43.851,23.053S425.056,164.707,424.964,164.879Z",
    transform: "translate(-337.597 -118.151)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(78.87 63.864)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M418.9,176.211c-.092.171-19.726-10.151-43.849-23.052s-43.611-23.5-43.52-23.674,19.721,10.148,43.852,23.054S419,176.039,418.9,176.211Z",
    transform: "translate(-331.536 -129.482)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(71.976 76.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M412.843,187.542c-.091.172-19.725-10.151-43.847-23.051s-43.612-23.5-43.52-23.674,19.72,10.148,43.852,23.054S412.935,187.371,412.843,187.542Z",
    transform: "translate(-325.476 -140.814)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(65.081 89.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M406.783,198.874c-.092.172-19.726-10.151-43.847-23.051s-43.612-23.5-43.521-23.674S339.136,162.3,363.267,175.2,406.874,198.7,406.783,198.874Z",
    transform: "translate(-319.415 -152.146)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(86.334 500.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_56",
    "data-name": "Group 56"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M743.1,439.864c0,.164-147.034.3-328.368.3-181.4,0-328.4-.133-328.4-.3s147-.3,328.4-.3C596.069,439.568,743.1,439.7,743.1,439.864Z",
    transform: "translate(-86.334 -439.568)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(110.611 429.101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57",
    "data-name": "Group 57",
    transform: "translate(7.866)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M118.795,377.2a14.34,14.34,0,0,1,9.994,5.118,25.316,25.316,0,0,1,5.087,10.251c1.925,7.194.742,15.683-1.311,22.842-7.787-2.784-12.59-11.089-14.761-15.455-3.432-6.9-5.445-21.457.991-22.755",
    transform: "translate(-114.589 -377.201)",
    fill: "#e3e1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(35.104 26.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M140.477,420.949a12.234,12.234,0,0,1-.573-12.27,16.252,16.252,0,0,1,9.784-7.864c1.9-.584,4.106-.828,5.758.275A5.234,5.234,0,0,1,157.46,406a10.6,10.6,0,0,1-2.24,5.034c-3.786,5.127-8.392,9.393-14.743,9.92",
    transform: "translate(-138.532 -400.32)",
    fill: "#e3e1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(35.639 34.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    "data-name": "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M141.269,443.935a8.6,8.6,0,0,1-.348-1.494c-.208-1.067-.478-2.445-.8-4.1-.614-3.448-1.59-8.35-.852-13.769a26.281,26.281,0,0,1,5.108-12.761,17.9,17.9,0,0,1,2.954-2.986,10.985,10.985,0,0,1,.927-.665c.217-.143.337-.21.347-.2a28.062,28.062,0,0,0-3.926,4.079,27.138,27.138,0,0,0-4.876,12.6c-.726,5.308.173,10.165.693,13.631.279,1.741.5,3.151.632,4.131A8.1,8.1,0,0,1,141.269,443.935Z",
    transform: "translate(-139.003 -407.961)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_62",
    "data-name": "Group 62",
    transform: "translate(14.581 10.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M120.494,386.826a3.139,3.139,0,0,1,.313.59c.208.448.474,1.023.8,1.734.688,1.51,1.655,3.706,2.828,6.431,2.346,5.448,5.482,13.02,8.756,21.458s6.062,16.15,8,21.756c.97,2.8,1.737,5.076,2.247,6.655.235.747.427,1.352.576,1.821a3.03,3.03,0,0,1,.166.647,3.187,3.187,0,0,1-.268-.612l-.672-1.787-2.407-6.6c-2.032-5.571-4.876-13.252-8.146-21.688s-6.35-16.023-8.6-21.506l-2.67-6.5c-.29-.728-.526-1.316-.709-1.773A3.094,3.094,0,0,1,120.494,386.826Z",
    transform: "translate(-120.492 -386.826)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    transform: "translate(0 41.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M136.336,427.277a28.613,28.613,0,0,0-22.208-13.8c-2.3-.167-5.071.22-6.1,2.287s.347,4.522,1.915,6.222a24.45,24.45,0,0,0,26.476,5.91",
    transform: "translate(-107.674 -413.445)",
    fill: "#e3e1ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    transform: "translate(9.959 47.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M116.429,418.894a7.466,7.466,0,0,1,1.441.053,13.964,13.964,0,0,1,1.681.195c.648.122,1.4.192,2.207.415a25.326,25.326,0,0,1,2.623.729,28.438,28.438,0,0,1,2.926,1.111,31.867,31.867,0,0,1,6.162,3.654,31.191,31.191,0,0,1,5.094,5.041,27.217,27.217,0,0,1,1.794,2.565,22.885,22.885,0,0,1,1.334,2.375,21.177,21.177,0,0,1,.917,2.05,12.9,12.9,0,0,1,.572,1.594,7.48,7.48,0,0,1,.375,1.392c-.115.041-.669-1.949-2.2-4.861a24.993,24.993,0,0,0-1.373-2.309,28.828,28.828,0,0,0-1.805-2.5,32.356,32.356,0,0,0-5.036-4.923,33.071,33.071,0,0,0-6.037-3.628,29.685,29.685,0,0,0-2.863-1.141,26.8,26.8,0,0,0-2.572-.783C118.474,419.122,116.417,419.011,116.429,418.894Z",
    transform: "translate(-116.429 -418.876)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(545.872 77.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(74.042 40.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M572.423,105.761c-3.344.77-4.974,4.619-5.291,8.037s.119,7.027-1.316,10.145c-1.615,3.509-5.474,6.1-5.6,9.957-.078,2.355,1.32,4.569,1.253,6.922-.11,3.868-4.053,6.789-4.26,10.652-.149,2.781,1.7,5.451,1.258,8.2-.347,2.14-2.012,3.826-2.717,5.876-1.4,4.087,1.4,8.587,5.061,10.888a16.589,16.589,0,0,0,24.17-7.723c2.024-4.913,1.581-10.445,1.142-15.74q-2.056-24.753-3.056-49.577",
    transform: "translate(-555.378 -103.399)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(7.33 3.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M561.824,163.549a4.011,4.011,0,0,0,1.529-1.818,6.452,6.452,0,0,0,.389-2.777,15.381,15.381,0,0,0-.829-3.684,10.51,10.51,0,0,1-.594-4.664c.287-1.772,1.554-3.226,2.711-4.656a10.382,10.382,0,0,0,1.536-2.334,3.77,3.77,0,0,0,.179-2.728c-.588-1.859-2.408-3.226-3.244-5.371a5.8,5.8,0,0,1-.183-3.319,13.477,13.477,0,0,1,1.1-2.978,25.482,25.482,0,0,0,2.26-5.352c.8-3.608.425-7.053.969-9.882a10.973,10.973,0,0,1,2.876-6.062,6.478,6.478,0,0,1,1.5-1.072,2.593,2.593,0,0,1,.6-.225,9.185,9.185,0,0,0-1.942,1.46,11.069,11.069,0,0,0-2.627,5.969,37.243,37.243,0,0,0-.316,4.6,28.105,28.105,0,0,1-.535,5.34,25.388,25.388,0,0,1-2.267,5.478c-.855,1.787-1.642,3.883-.884,5.842.722,1.936,2.555,3.312,3.242,5.4a4.343,4.343,0,0,1-.212,3.127,10.867,10.867,0,0,1-1.631,2.454c-1.189,1.437-2.38,2.805-2.652,4.4a10.239,10.239,0,0,0,.513,4.464,15.17,15.17,0,0,1,.758,3.784,6.49,6.49,0,0,1-.509,2.884,3.458,3.458,0,0,1-1.166,1.436A1.878,1.878,0,0,1,561.824,163.549Z",
    transform: "translate(-561.821 -106.624)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M561.236,180.366l-10.269,29.6-42.822,2.3L501,228.154l44.707,4.524a16.893,16.893,0,0,0,22.355-9.914L580,189.461Z",
    transform: "translate(-488.817 -52.635)",
    fill: "#dec2b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(81.416 210.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73",
    "data-name": "Group 73"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M641.439,449.418s-31.383-99.672-32.048-102.909c-.6-2.925,11.39-74.652,12.9-93.217l-42.4,1.581,0,.309-18.024,1L578,460.031h19.513L595.582,392.4c12.031,32.3,29.275,65.224,29.275,65.224Z",
    transform: "translate(-561.86 -253.293)",
    fill: "#dec2b8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_72",
    "data-name": "Group 72",
    transform: "translate(26.973 120.299)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M593.116,402.09c.017-.619-.237-22.66-.237-22.66-.243,1.318-7.481-19.138-7.306-20.381C585.663,358.4,593.116,402.09,593.116,402.09Z",
    transform: "translate(-585.57 -359.042)",
    fill: "#dec2b8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(25.993 110.622)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M584.866,350.535a4.564,4.564,0,0,0-.125,1.235,32.6,32.6,0,0,0,.026,3.379c.027.716.1,1.495.195,2.331s.221,1.729.414,2.655a45.3,45.3,0,0,0,1.595,5.938c1.416,4.124,2.979,7.73,4.09,10.348q.79,1.79,1.358,3.082a4.562,4.562,0,0,0,.579,1.1,4.663,4.663,0,0,0-.345-1.192c-.262-.752-.66-1.832-1.167-3.159-1-2.661-2.5-6.3-3.9-10.382a51.517,51.517,0,0,1-1.623-5.851c-.206-.909-.338-1.787-.466-2.606s-.214-1.589-.271-2.295c-.134-1.408-.195-2.555-.23-3.348A4.624,4.624,0,0,0,584.866,350.535Z",
    transform: "translate(-584.709 -350.535)",
    fill: "#a36957"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(83.761 415.733)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M577.352,436.237l-.008-1.833,19.988-.87.055,7.559-1.233.083c-5.485.321-27.918,1.246-31.59.146C560.468,440.093,577.352,436.237,577.352,436.237Z",
    transform: "translate(-563.923 -433.534)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(0 7.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M597.665,439.777a1.734,1.734,0,0,1-.341.039l-.982.063-3.614.17c-3.052.121-7.271.231-11.932.253s-8.882-.055-11.936-.149l-3.615-.137-.982-.055a1.747,1.747,0,0,1-.342-.035,1.872,1.872,0,0,1,.344-.013l.984.009,3.615.06c3.053.05,7.272.1,11.931.077s8.875-.1,11.929-.182l3.615-.092.983-.018A1.892,1.892,0,0,1,597.665,439.777Z",
    transform: "translate(-563.921 -439.767)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(5.037 4.637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M570.268,440.719a5.253,5.253,0,0,0-1.918-3.1,3.211,3.211,0,0,1,1.918,3.1Z",
    transform: "translate(-568.349 -437.611)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(11.747 3.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M575.314,437.907c-.057.035-.339-.3-.63-.761s-.482-.854-.427-.89.338.3.629.76S575.37,437.872,575.314,437.907Z",
    transform: "translate(-574.247 -436.254)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(13.17 2.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M576.748,437.088c-.044.05-.358-.158-.7-.464s-.587-.6-.543-.645.359.158.7.464S576.793,437.039,576.748,437.088Z",
    transform: "translate(-575.498 -435.971)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(13.354 1.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M577.737,435.313a2.32,2.32,0,0,1-1.038.137,2.363,2.363,0,0,1-1.04-.1,2.336,2.336,0,0,1,1.036-.137A2.366,2.366,0,0,1,577.737,435.313Z",
    transform: "translate(-575.66 -435.207)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(13.423 0.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M578.074,434.138a2.929,2.929,0,0,1-2.353.185,6.5,6.5,0,0,1,1.177-.085A6.426,6.426,0,0,1,578.074,434.138Z",
    transform: "translate(-575.721 -434.119)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(8.381 1.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M575.04,436.4a3.667,3.667,0,0,1-1.278,0,7.494,7.494,0,0,1-1.362-.295,3.737,3.737,0,0,1-.78-.319.687.687,0,0,1-.317-.395.5.5,0,0,1,.192-.512,2.343,2.343,0,0,1,2.9.675,2.273,2.273,0,0,1,.42.851.723.723,0,0,1,.035.346,3.627,3.627,0,0,0-.587-1.089,2.3,2.3,0,0,0-1.093-.705,1.988,1.988,0,0,0-1.523.109c-.2.151-.122.39.1.523a3.878,3.878,0,0,0,.72.3,8.844,8.844,0,0,0,1.317.337C574.553,436.36,575.04,436.36,575.04,436.4Z",
    transform: "translate(-571.288 -434.621)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(11.641 0.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M574.314,436.541a1.263,1.263,0,0,1-.15-.886,2.083,2.083,0,0,1,.346-.935,1.28,1.28,0,0,1,1.061-.655.509.509,0,0,1,.4.588,1.413,1.413,0,0,1-.215.572,3.847,3.847,0,0,1-.6.775,1.837,1.837,0,0,1-.729.52c-.023-.031.254-.23.6-.636a4.469,4.469,0,0,0,.532-.768c.174-.271.292-.757-.028-.813-.32-.03-.645.29-.84.545a2.126,2.126,0,0,0-.358.833A4.779,4.779,0,0,0,574.314,436.541Z",
    transform: "translate(-574.154 -434.063)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(26.271 1.532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M594.063,435.011c0,.044-.57-.052-1.468.057a6.228,6.228,0,0,0-5.194,4.17c-.3.853-.328,1.427-.372,1.421a1.132,1.132,0,0,1,0-.4,5.208,5.208,0,0,1,.213-1.074,6.041,6.041,0,0,1,5.339-4.286,5.227,5.227,0,0,1,1.093.024A1.125,1.125,0,0,1,594.063,435.011Z",
    transform: "translate(-587.014 -434.881)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(17.935 5.493)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M585.5,438.387a16.339,16.339,0,0,1-5.812.032c.007-.071,1.3.015,2.907,0S585.491,438.318,585.5,438.387Z",
    transform: "translate(-579.687 -438.362)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(27.078 5.468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M588.289,438.348c.048.048-.106.275-.238.573s-.2.563-.271.56-.1-.314.051-.657S588.246,438.3,588.289,438.348Z",
    transform: "translate(-587.724 -438.34)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(28.353 3.632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M589.6,436.736c.048.047-.08.255-.286.463s-.409.341-.457.295.081-.254.286-.463S589.549,436.69,589.6,436.736Z",
    transform: "translate(-588.845 -436.727)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(30.07 2.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M591.488,436.008c-.014.068-.279.066-.57.171s-.5.259-.554.215.113-.32.476-.444S591.508,435.946,591.488,436.008Z",
    transform: "translate(-590.354 -435.895)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(32.099 2.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M592.738,435.648c.024.063-.09.165-.255.229s-.317.067-.342.006.09-.165.255-.23S592.713,435.587,592.738,435.648Z",
    transform: "translate(-592.137 -435.604)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_139",
    "data-name": "Group 139",
    transform: "translate(133.63 406.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_138",
    "data-name": "Group 138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_109",
    "data-name": "Group 109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M618.15,435.648l-.759-1.668L635.268,425l3.147,6.873-1.091.581c-4.873,2.54-24.959,12.573-28.758,13.073C604.327,446.082,618.15,435.648,618.15,435.648Z",
    transform: "translate(-607.758 -424.998)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_111",
    "data-name": "Group 111",
    transform: "translate(0.001 6.341)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_110",
    "data-name": "Group 110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M638.482,430.573a1.994,1.994,0,0,1-.3.175l-.869.46-3.227,1.634c-2.735,1.361-6.539,3.19-10.782,5.119s-8.126,3.588-10.949,4.753L609,444.07l-.918.353a1.8,1.8,0,0,1-.327.108,1.741,1.741,0,0,1,.307-.152l.9-.395,3.324-1.427c2.805-1.2,6.673-2.889,10.915-4.817s8.054-3.73,10.807-5.051l3.26-1.565.89-.419A1.911,1.911,0,0,1,638.482,430.573Z",
    transform: "translate(-607.759 -430.572)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    "data-name": "Group 113",
    transform: "translate(3.529 15.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_112",
    "data-name": "Group 112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M613.881,440.986a5.26,5.26,0,0,0-3.021-2.044,3.212,3.212,0,0,1,3.021,2.044Z",
    transform: "translate(-610.86 -438.915)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_115",
    "data-name": "Group 115",
    transform: "translate(9.022 11.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M617.332,436.353c-.036.056-.433-.14-.886-.436s-.791-.582-.754-.638.433.14.886.437S617.368,436.3,617.332,436.353Z",
    transform: "translate(-615.689 -435.27)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(10.189 10.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M618.305,435.02c-.02.064-.392,0-.832-.137s-.779-.3-.759-.366.392,0,.832.136S618.325,434.956,618.305,435.02Z",
    transform: "translate(-616.714 -434.492)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(10.048 9.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M618.475,433.086c.027.06-.371.306-.891.548a2.341,2.341,0,0,1-.992.331c-.028-.06.37-.306.89-.549A2.347,2.347,0,0,1,618.475,433.086Z",
    transform: "translate(-616.591 -433.072)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_121",
    "data-name": "Group 121",
    transform: "translate(9.633 7.843)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M618.3,431.9c.044.046-.322.462-.916.785a2.025,2.025,0,0,1-1.155.349,6.282,6.282,0,0,1,1.039-.561A6.494,6.494,0,0,1,618.3,431.9Z",
    transform: "translate(-616.226 -431.892)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(5.412 10.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_122",
    "data-name": "Group 122"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M616.437,435.173a3.684,3.684,0,0,1-1.167.52,7.442,7.442,0,0,1-1.363.289,3.682,3.682,0,0,1-.842.03.693.693,0,0,1-.452-.231.5.5,0,0,1-.034-.545,2.342,2.342,0,0,1,2.921-.572,2.282,2.282,0,0,1,.733.6c.136.177.184.293.172.3a3.605,3.605,0,0,0-.979-.752,2.3,2.3,0,0,0-1.288-.2,1.981,1.981,0,0,0-1.344.723c-.123.221.048.4.308.435a3.826,3.826,0,0,0,.782-.017,8.687,8.687,0,0,0,1.34-.232C615.977,435.337,616.421,435.137,616.437,435.173Z",
    transform: "translate(-612.515 -434.386)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(8.46 8.878)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M615.793,435.586a1.26,1.26,0,0,1-.5-.747,2.11,2.11,0,0,1-.068-.994,1.286,1.286,0,0,1,.7-1.033c.286-.088.952.487,1,.7.072.214-.337.1-.357.283a3.917,3.917,0,0,1-.231.953,1.822,1.822,0,0,1-.453.772c-.033-.019.138-.314.291-.827a4.47,4.47,0,0,0,.171-.92c.049-.317-.042-.809-.358-.73-.3.1-.47.529-.543.842a2.109,2.109,0,0,0,.014.907A4.72,4.72,0,0,0,615.793,435.586Z",
    transform: "translate(-615.195 -432.802)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    transform: "translate(23.542 1.55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M633.018,426.365c.014.043-.542.187-1.316.654a6.228,6.228,0,0,0-3.029,5.931c.075.9.286,1.436.242,1.449a1.163,1.163,0,0,1-.166-.365,5.214,5.214,0,0,1-.246-1.066,6.044,6.044,0,0,1,3.114-6.1,5.257,5.257,0,0,1,1.008-.427A1.184,1.184,0,0,1,633.018,426.365Z",
    transform: "translate(-628.453 -426.361)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_129",
    "data-name": "Group 129",
    transform: "translate(15.666 8.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M626.818,432.9a16.311,16.311,0,0,1-5.289,2.408c-.023-.066,1.2-.52,2.653-1.186S626.782,432.842,626.818,432.9Z",
    transform: "translate(-621.529 -432.899)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(24.269 7.356)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M629.314,431.466c.064.024.017.295.019.62s.045.6-.019.621-.223-.243-.222-.62S629.255,431.44,629.314,431.466Z",
    transform: "translate(-629.092 -431.464)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_133",
    "data-name": "Group 133",
    transform: "translate(24.675 5.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_132",
    "data-name": "Group 132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M629.847,429.469c.063.023.032.265-.069.539s-.234.479-.3.456-.031-.264.071-.539S629.786,429.447,629.847,429.469Z",
    transform: "translate(-629.449 -429.467)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(25.75 3.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M631.287,428.042c.015.067-.226.174-.45.388s-.35.443-.416.423-.028-.338.253-.6S631.28,427.977,631.287,428.042Z",
    transform: "translate(-630.393 -428.009)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(27.379 2.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M632.29,427.181c.048.047-.015.187-.139.313s-.263.191-.309.146.014-.188.138-.314S632.242,427.134,632.29,427.181Z",
    transform: "translate(-631.826 -427.166)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(61.93 97.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(0.22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_144",
    "data-name": "Group 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_143",
    "data-name": "Group 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_142",
    "data-name": "Group 142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M621.871,233.273l-3.329-40.609,17.1.3s.792-5.987-1.727-19.122c-1.545-8.053-6.909-12.992-12.924-15.927v-.108l-.521-.137a48.855,48.855,0,0,0-15.66-4.086l-20.985.242s-16.031-2-24.9,9.428c-3.418,4.4-13.995,34.532-13.995,34.532l25.189,12.131-2.4-16.708s.476,12.113,2.023,15.951c.861,2.139,3.355,8.779,3.355,8.779l-.325,20.038Z",
    transform: "translate(-544.924 -153.589)",
    fill: "#635bff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_145",
    "data-name": "Group 145",
    transform: "translate(62.255 24.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M602.763,183.842l-3.115,13.271h29.385L627.1,174.864Z",
    transform: "translate(-599.649 -174.864)",
    fill: "#635bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(65.024 45.821)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M628.7,194.5a21.876,21.876,0,0,0-3.889-.386c-2.408-.141-5.74-.259-9.424-.243s-7.017.177-9.423.369a20.989,20.989,0,0,0-3.88.479,26.245,26.245,0,0,0,3.905-.022c2.406-.074,5.729-.16,9.4-.179s7,.031,9.4.055A24.949,24.949,0,0,0,628.7,194.5Z",
    transform: "translate(-602.083 -193.868)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(63.998 24.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M601.286,174.768a17.622,17.622,0,0,0-.1,3.376c.023,2.082.1,4.956.221,8.13s.271,6.046.411,8.125a17.476,17.476,0,0,0,.359,3.357,17.371,17.371,0,0,0,.1-3.375c-.022-2.082-.1-4.958-.221-8.132s-.271-6.046-.41-8.124A17.435,17.435,0,0,0,601.286,174.768Z",
    transform: "translate(-601.181 -174.768)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(37.363 35.587)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M577.768,184.872S584.3,233.3,602.66,232.015c0,0,8.266-.1,10.924-5.592V224.26Z",
    transform: "translate(-577.768 -184.872)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(60.808 26.948)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M601.7,177.277l-3.515,23.739,2.275,4.165,3.746-8.145L602.62,197Z",
    transform: "translate(-598.184 -177.277)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(22.511 33.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M570.4,213.872a4.981,4.981,0,0,1-.5-1.134c-.286-.742-.664-1.828-1.1-3.178a96.613,96.613,0,0,1-2.811-10.746,77.663,77.663,0,0,1-1.392-11.024c-.068-1.421-.089-2.571-.068-3.366a4.974,4.974,0,0,1,.085-1.235c.094,0,.158,1.753.4,4.573a102.486,102.486,0,0,0,1.555,10.938c.844,4.233,1.858,8.013,2.63,10.739q.541,1.9.922,3.228A5.006,5.006,0,0,1,570.4,213.872Z",
    transform: "translate(-564.518 -183.188)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(34.297 73.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M576.4,222.978c-.157.048-.611-1-1.015-2.333a5.629,5.629,0,0,1-.448-2.5c.156-.048.611,1,1.015,2.333A5.645,5.645,0,0,1,576.4,222.978Z",
    transform: "translate(-574.879 -218.139)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(37.678 70.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M578.524,223.089a10.489,10.489,0,0,1-.1-7.1,23.863,23.863,0,0,1,.025,3.55A23.921,23.921,0,0,1,578.524,223.089Z",
    transform: "translate(-577.852 -215.99)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 43.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M570.651,205.163c-.074.147-5.936-2.635-13.091-6.21s-12.9-6.6-12.829-6.741,5.934,2.634,13.093,6.211S570.724,205.018,570.651,205.163Z",
    transform: "translate(-544.73 -192.206)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(89.41 38.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193",
    transform: "translate(0 7.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M577.657,163.978c.131-5.755.163-11.816.163-11.816s-7.382-1.422-8.667-11.135c-1.227-9.262,2.2-31,2.2-31h0c10.783-4.076,21.987-.381,29.376,8.356h0L598.9,165.112c-.214,5.424-5.047,9.561-10.854,9.29h0C582.18,174.127,577.532,169.461,577.657,163.978Z",
    transform: "translate(-568.887 -108.375)",
    fill: "#dec2b8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(1.429 16.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0.478 1.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M570.565,125.232a1.241,1.241,0,0,0,1.164,1.282,1.186,1.186,0,0,0,1.307-1.085,1.242,1.242,0,0,0-1.163-1.283A1.187,1.187,0,0,0,570.565,125.232Z",
    transform: "translate(-570.563 -124.141)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M570.161,123.817c.149.166,1.107-.505,2.442-.468,1.333.019,2.3.731,2.445.571.073-.071-.076-.366-.495-.688a3.41,3.41,0,0,0-1.952-.658,3.276,3.276,0,0,0-1.949.574C570.234,123.454,570.087,123.743,570.161,123.817Z",
    transform: "translate(-570.143 -122.574)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(15.344 16.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(0.107 1.78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M582.471,125.973a1.24,1.24,0,0,0,1.164,1.282,1.185,1.185,0,0,0,1.307-1.085,1.242,1.242,0,0,0-1.163-1.283A1.187,1.187,0,0,0,582.471,125.973Z",
    transform: "translate(-582.469 -124.882)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M582.393,124.559c.15.166,1.109-.505,2.442-.466,1.334.018,2.3.73,2.446.571.073-.071-.075-.367-.5-.688a3.4,3.4,0,0,0-1.951-.658,3.261,3.261,0,0,0-1.949.574C582.467,124.2,582.32,124.485,582.393,124.559Z",
    transform: "translate(-582.375 -123.317)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(6.886 16.908)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M578.316,134.345a8.776,8.776,0,0,0-2.158-.447c-.34-.044-.661-.121-.712-.355a1.739,1.739,0,0,1,.254-1q.514-1.225,1.075-2.569a44.514,44.514,0,0,0,2.439-6.731,44.646,44.646,0,0,0-2.975,6.518q-.541,1.353-1.033,2.587a1.973,1.973,0,0,0-.212,1.332.856.856,0,0,0,.547.513,2.319,2.319,0,0,0,.578.1A8.721,8.721,0,0,0,578.316,134.345Z",
    transform: "translate(-574.94 -123.238)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(8.933 40.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M576.739,147.243a24.613,24.613,0,0,0,13.044-3.12s-3.315,6.563-12.972,5.408Z",
    transform: "translate(-576.739 -144.123)",
    fill: "#a36957"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195",
    transform: "translate(14.954 20.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M586.713,121.241c-.273.417-1.289.232-2.427.027-1.133-.228-2.145-.43-2.247-.919-.113-.469,1.063-1.118,2.58-.826S586.991,120.846,586.713,121.241Z",
    transform: "translate(-582.032 -119.45)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    transform: "translate(1.404 18.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M575.08,119.429c-.1.486-1.19.663-2.444.728s-2.354-.026-2.5-.5c-.149-.46.911-1.207,2.42-1.274S575.187,118.957,575.08,119.429Z",
    transform: "translate(-570.121 -118.376)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(9.457 38.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M578.027,135.816a.674.674,0,0,0-.738.338.759.759,0,1,0,.454-.362",
    transform: "translate(-577.2 -135.765)",
    fill: "#a36957"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200",
    transform: "translate(9.03 38.611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M578.392,135.96c.06-.053-.214-.381-.8-.254a1.012,1.012,0,0,0-.73.714,1.144,1.144,0,0,0,.4,1.209,1.124,1.124,0,0,0,1.28.008.961.961,0,0,0,.411-.949c-.117-.6-.561-.7-.573-.612-.05.076.155.283.115.638a.5.5,0,0,1-.271.418.577.577,0,0,1-.577-.025.6.6,0,0,1-.2-.551.576.576,0,0,1,.307-.421C578.068,135.958,578.349,136.042,578.392,135.96Z",
    transform: "translate(-576.825 -135.677)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(1.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M596.03,130.713c-1.151,2.667-3.959,4.721-3.57,7.6.251,1.858,1.444,3.59,1.212,5.451-.291,2.337-2.719,3.957-3.062,6.285-.421,2.858,2.358,5.078,3.469,7.745,1.617,3.883-.452,8.25-.5,12.455A13.355,13.355,0,0,0,605.4,183.239c2.6.214,5.523-.57,6.869-2.8,1.111-1.842.89-4.18,1.555-6.224.993-3.044,3.894-5.273,4.506-8.416,1.115-5.73-5.81-10.472-5.354-16.291.194-2.486,1.729-4.655,2.382-7.062a10.348,10.348,0,0,0-2.032-9.205c-1.709-2.033-4.189-3.37-5.644-5.59-1.651-2.519-1.708-5.712-2.331-8.658a21.811,21.811,0,0,0-34.642-12.776s-1.654,7.5,6.042,8.751,11.263-.193,12.131,2.892a8.156,8.156,0,0,0,2.3,7.045C594.372,128.345,597.362,127.625,596.03,130.713Z",
    transform: "translate(-570.563 -101.736)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(24.938 20.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M605.3,180.178a3.162,3.162,0,0,1-.7-.073,10.4,10.4,0,0,1-1.958-.529,13.808,13.808,0,0,1-5.954-4.408,15.6,15.6,0,0,1-2.532-4.506,18.094,18.094,0,0,1-1.034-5.84,23.788,23.788,0,0,1,.82-6.5,28.347,28.347,0,0,1,1.089-3.291,32.775,32.775,0,0,0,1.249-3.268,6.144,6.144,0,0,0-.011-3.337,18.159,18.159,0,0,0-1.293-3.115,20.773,20.773,0,0,1-1.325-3.083,6.661,6.661,0,0,1-.239-3.269c.453-2.143,1.754-3.729,2.523-5.356a10.188,10.188,0,0,0,1.029-4.846,11.452,11.452,0,0,0-2.537-6.711,20.3,20.3,0,0,0-1.933-1.882,7.863,7.863,0,0,1,2.108,1.731,11.409,11.409,0,0,1,2.78,6.843,10.526,10.526,0,0,1-1.007,5.078c-.784,1.687-2.041,3.284-2.429,5.245s.536,4.011,1.548,5.992a18.5,18.5,0,0,1,1.342,3.217,6.744,6.744,0,0,1,.015,3.645,32.687,32.687,0,0,1-1.273,3.333,27.989,27.989,0,0,0-1.076,3.222,23.54,23.54,0,0,0-.835,6.339,16.415,16.415,0,0,0,3.349,10.1,14.035,14.035,0,0,0,5.711,4.454C604.33,180.013,605.309,180.111,605.3,180.178Z",
    transform: "translate(-592.485 -120.169)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(2.752 3.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M606.846,124.9a8.062,8.062,0,0,1-1.7.253,17.668,17.668,0,0,1-4.686-.123,8.908,8.908,0,0,1-5.912-3.588A19.256,19.256,0,0,1,593,117.618a6.311,6.311,0,0,0-2.591-3.2c-2.489-1.578-5.417-1.771-7.979-2.083-2.574-.29-4.992-.836-6.631-2.065a6.573,6.573,0,0,1-2.714-3.8,4.089,4.089,0,0,1-.088-1.282,1.307,1.307,0,0,1,.092-.439,8.356,8.356,0,0,0,.22,1.665,6.549,6.549,0,0,0,2.73,3.512c1.578,1.118,3.891,1.606,6.455,1.866,2.539.287,5.571.445,8.236,2.128a6.846,6.846,0,0,1,2.811,3.486,19.672,19.672,0,0,0,1.471,3.734,8.593,8.593,0,0,0,5.532,3.471,19.9,19.9,0,0,0,4.592.3A11.539,11.539,0,0,1,606.846,124.9Z",
    transform: "translate(-572.981 -104.752)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207",
    transform: "translate(4.838 1.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M603.77,115.809a3.46,3.46,0,0,1-1.333.2,8.157,8.157,0,0,1-5.705-2.279,10.813,10.813,0,0,1-1.764-2.355c-1.026-1.73-2.014-3.864-4.141-4.746-2.084-.894-4.38-.7-6.373-.561a19.48,19.48,0,0,1-5.44-.046,6.776,6.776,0,0,1-3.357-1.505,3.865,3.865,0,0,1-.669-.751c-.128-.191-.185-.3-.169-.308.048-.036.319.366.985.881a6.986,6.986,0,0,0,3.28,1.271,20.5,20.5,0,0,0,5.323-.085c2.006-.158,4.368-.41,6.661.562a6.578,6.578,0,0,1,2.715,2.256,30.108,30.108,0,0,1,1.656,2.758,10.67,10.67,0,0,0,1.639,2.281,7.83,7.83,0,0,0,1.957,1.445,8.438,8.438,0,0,0,3.408.952C603.289,115.824,603.763,115.758,603.77,115.809Z",
    transform: "translate(-574.816 -103.454)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(33.113 24.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M607.7,177.338c-.058-.026.3-.759.725-2.158a19.585,19.585,0,0,0,.758-6.1,18.734,18.734,0,0,0-2.425-8.687c-.832-1.49-2.1-2.818-3.126-4.454a8.051,8.051,0,0,1-1.147-2.746,6.208,6.208,0,0,1,.253-3.07c.637-1.963,1.78-3.619,2.026-5.424.3-1.811-.611-3.463-1.475-4.931a22.687,22.687,0,0,1-1.218-2.262,8.132,8.132,0,0,1-.644-2.375,21.061,21.061,0,0,1,.129-4.338,11.474,11.474,0,0,0-.539-6.045,5.482,5.482,0,0,0-1.342-1.78c.006-.009.052.013.138.065a2.3,2.3,0,0,1,.363.259,4.207,4.207,0,0,1,1.05,1.355,11.269,11.269,0,0,1,.749,6.182,21.359,21.359,0,0,0-.058,4.242,10.772,10.772,0,0,0,1.844,4.418A15.028,15.028,0,0,1,605,141.91a5.735,5.735,0,0,1,.342,2.871c-.276,1.991-1.449,3.673-2.036,5.523a5.644,5.644,0,0,0-.237,2.785,7.518,7.518,0,0,0,1.059,2.547c.976,1.572,2.247,2.926,3.106,4.487a18.783,18.783,0,0,1,2.372,8.949,18.4,18.4,0,0,1-.957,6.177,13.445,13.445,0,0,1-.655,1.571A2.236,2.236,0,0,1,607.7,177.338Z",
    transform: "translate(-599.67 -122.968)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(77.825 173.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(0.184 0.291)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M566.977,375.817s-7.662-72.626-8.1-99.463,12.065-53.314,12.065-53.314l49.011-2.073s9.688,27.229,9.861,38.667c.338,22.226-5.905,44.176-5.186,61.808l1.639,54.376",
    transform: "translate(-558.865 -220.967)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(6.687 65.856)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M627.119,278.6a6.573,6.573,0,0,1-.8.605l-.446.315c-.154.13-.3.295-.476.458a7.3,7.3,0,0,0-1.091,1.223c-1.584,1.938-2.737,5.4-3.835,9.721a32.673,32.673,0,0,1-2.481,6.91,12.456,12.456,0,0,1-1.089,1.72c-.212.273-.4.565-.639.827l-.755.754a12.184,12.184,0,0,1-3.686,2.365c-2.744,1.2-5.84,1.774-8.67,3.192a13.7,13.7,0,0,0-6.29,7.17c-1.38,3.083-2.217,6.319-3.368,9.34-1.131,3-2.671,5.917-5.117,7.76-2.425,1.91-5.424,2.347-8.02,2.514-2.639.154-5.083.077-7.274.41a11.494,11.494,0,0,0-5.487,2.07,7.639,7.639,0,0,0-2.549,3.589,5.385,5.385,0,0,0-.19,2.789c.126.639.306.945.266.961a2.923,2.923,0,0,1-.382-.934,5.3,5.3,0,0,1,.085-2.885,7.8,7.8,0,0,1,2.563-3.78,11.723,11.723,0,0,1,5.631-2.225c2.232-.364,4.7-.312,7.3-.486,2.571-.187,5.441-.637,7.722-2.457,2.309-1.758,3.795-4.564,4.905-7.532,1.131-2.986,1.962-6.227,3.371-9.377a14.247,14.247,0,0,1,6.567-7.444c2.943-1.461,6.041-2.014,8.715-3.175a11.732,11.732,0,0,0,3.549-2.246l.724-.713c.226-.249.413-.53.619-.789a12.007,12.007,0,0,0,1.063-1.652,32.837,32.837,0,0,0,2.51-6.788c1.147-4.3,2.382-7.815,4.057-9.751a7.238,7.238,0,0,1,1.155-1.209c.181-.16.34-.32.5-.445l.47-.3A6.342,6.342,0,0,1,627.119,278.6Z",
    transform: "translate(-564.582 -278.602)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(2.006 32.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M627.988,249.059a5.9,5.9,0,0,1,.064.973,12.074,12.074,0,0,1-.34,2.779,17.974,17.974,0,0,1-5.537,8.56,32.9,32.9,0,0,1-5.74,4.192c-2.2,1.3-4.619,2.545-7.1,3.946a37.131,37.131,0,0,0-7.263,5.108,28.058,28.058,0,0,0-5.5,7.733,71.371,71.371,0,0,1-4.771,8.406,20.085,20.085,0,0,1-3.111,3.44,19.618,19.618,0,0,1-3.7,2.464,45.826,45.826,0,0,1-7.615,2.919c-2.432.753-4.7,1.419-6.683,2.249a26.07,26.07,0,0,0-5.1,2.73,15.851,15.851,0,0,0-3.2,2.951,15.276,15.276,0,0,0-1.92,3.191,5.982,5.982,0,0,1,.316-.923,11.267,11.267,0,0,1,1.422-2.411,15.561,15.561,0,0,1,3.189-3.077,25.81,25.81,0,0,1,5.128-2.849c2-.866,4.28-1.56,6.7-2.331a46.036,46.036,0,0,0,7.509-2.934,19.185,19.185,0,0,0,3.585-2.409,19.588,19.588,0,0,0,3.008-3.35,72.07,72.07,0,0,0,4.72-8.345,28.485,28.485,0,0,1,5.626-7.877,37.282,37.282,0,0,1,7.4-5.161c2.5-1.4,4.93-2.619,7.12-3.894a33.025,33.025,0,0,0,5.706-4.078,18.123,18.123,0,0,0,5.6-8.31A17.584,17.584,0,0,0,627.988,249.059Z",
    transform: "translate(-560.467 -249.059)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M559.145,280.237a.735.735,0,0,1-.1-.221,4.882,4.882,0,0,1-.107-3.4c.633-2.316,3.149-5.2,7.2-6.642,2.017-.693,4.307-1.111,6.691-1.736a12.533,12.533,0,0,0,9.271-6.9,35.019,35.019,0,0,0,1.7-4.087c1.02-2.837,1.876-5.92,3.606-8.723a13.929,13.929,0,0,1,7.422-5.77,67.9,67.9,0,0,1,8.515-2.158,28.2,28.2,0,0,0,7.4-2.521,15.5,15.5,0,0,0,5.011-4.514,16.924,16.924,0,0,0,3.184-9.215,26.37,26.37,0,0,0-.242-3.636,12.009,12.009,0,0,1,.472,3.64A16.805,16.805,0,0,1,616.1,233.8a15.815,15.815,0,0,1-5.112,4.7,28.4,28.4,0,0,1-7.522,2.624,69.094,69.094,0,0,0-8.435,2.169,13.374,13.374,0,0,0-7.12,5.541c-1.671,2.7-2.53,5.747-3.563,8.6a35.191,35.191,0,0,1-1.743,4.153,13.011,13.011,0,0,1-9.65,7.113c-2.418.611-4.695,1-6.683,1.659-3.944,1.346-6.448,4.108-7.116,6.313a5.561,5.561,0,0,0-.217,2.636C559.07,279.914,559.172,280.226,559.145,280.237Z",
    transform: "translate(-558.703 -220.711)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(8.251 120.935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M623.018,327.019a3.226,3.226,0,0,1,.078.713,7.587,7.587,0,0,1-.209,2.055,11.679,11.679,0,0,1-4.3,6.145,19.17,19.17,0,0,1-4.511,2.679,59.666,59.666,0,0,1-5.664,1.958,46.8,46.8,0,0,0-6.152,2.247,17.769,17.769,0,0,0-5.6,4.084c-1.66,1.738-3.092,3.637-4.681,5.314a21.423,21.423,0,0,1-5.242,4.1,23.037,23.037,0,0,1-10.819,2.813,21.451,21.451,0,0,1-7.447-1.238,13.625,13.625,0,0,1-1.89-.81,3.262,3.262,0,0,1-.626-.347,3.3,3.3,0,0,1,.676.239,18.3,18.3,0,0,0,1.913.7,22.454,22.454,0,0,0,7.365,1.036,22.976,22.976,0,0,0,10.56-2.87,21.081,21.081,0,0,0,5.086-4.025c1.556-1.652,2.982-3.55,4.674-5.325a18.246,18.246,0,0,1,5.779-4.2,46.051,46.051,0,0,1,6.241-2.243c2.011-.612,3.922-1.18,5.633-1.89a19.084,19.084,0,0,0,4.442-2.555,11.738,11.738,0,0,0,4.336-5.876A13.442,13.442,0,0,0,623.018,327.019Z",
    transform: "translate(-565.957 -327.019)",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(88.743 86.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M617.108,201.364l-9.476.224a15.5,15.5,0,0,1-2.143,5.376c-7.925-13.756-14.069-32.186-15.594-39.592.222-.741.484-1.559.813-2.473.379-1.057.055-3.056-.125-4.166-.265-1.648-.727-3.868-.866-4.9-.422-3.13-.926-3.621-2.018-3.267-1.485.481.61,8.79-.608,8.97-.654.1-1.454-2.75-1.686-5.085s-1.288-9.519-2.06-10c-1.132-.7-2.118.408-1.832,2.734.289,2.355.654,9.374-.58,9.468-1.216.094-2.238-11.816-2.238-11.816s.192-2.591-1.237-2.53c-2.578.113-.563,12.669-.342,13.858.153.828-1.185.979-1.3.082-.122-.925-.744-11.912-3.367-11.823-2.015.068,1.56,10.348.429,12.731s-1.917-8.093-3.839-7.948c-.716.053-1.246.193.071,6.121a133.692,133.692,0,0,0,4.6,13.9c3.048,16.437,16.423,69.025,37.394,59.4,11.733-5.387,16.494-29.26,16.494-29.26Z",
    transform: "translate(-568.301 -144.217)",
    fill: "#dec2b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(7.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M575.714,158.989a.645.645,0,0,0,.273-.038.608.608,0,0,0,.428-.656c-.027-.706-.138-1.735-.3-3.065a44.219,44.219,0,0,1-.523-4.847c-.015-.952.009-1.976.064-3.061a10.669,10.669,0,0,1,.166-1.638c.089-.515.433-1.1.832-1.034l.044.008h.019c.4-.018.721.3.851.779a4.477,4.477,0,0,1,.149,1.522v.036a92.193,92.193,0,0,0,1.216,9.5c.092.424.187.852.319,1.283a6.18,6.18,0,0,0,.237.652,2.032,2.032,0,0,0,.193.338.619.619,0,0,0,.475.3.851.851,0,0,0,.716-.6,3.433,3.433,0,0,0,.213-.7,10.519,10.519,0,0,0,.183-1.388,41.484,41.484,0,0,0-.076-5.69,13.16,13.16,0,0,1-.118-2.85,1.58,1.58,0,0,1,.56-1.061.615.615,0,0,1,.489-.063,1.161,1.161,0,0,1,.271.117.37.37,0,0,1,.125.168,14.216,14.216,0,0,1,.789,2.859c.2,1.008.377,2.033.537,3.07s.307,2.087.431,3.145a21.809,21.809,0,0,0,.524,3.235,10.747,10.747,0,0,0,.513,1.607,2.873,2.873,0,0,0,.469.8.675.675,0,0,0,.68.248.728.728,0,0,0,.465-.511,5.589,5.589,0,0,0,.119-1.77c-.024-.564-.07-1.122-.118-1.68-.081-.958-.173-1.905-.2-2.839a9.542,9.542,0,0,1,.034-1.369,2.182,2.182,0,0,1,.138-.594.536.536,0,0,1,.109-.169c.018-.018.03-.01.044-.028l.148-.042c.754-.312,1.006.738,1.206,1.585.175.882.286,1.794.463,2.692.3,1.792.683,3.572.883,5.284a6.112,6.112,0,0,1-.1,2.448q-.4,1.234-.8,2.44l-.024.073.017.076a131.577,131.577,0,0,0,5.09,16.448c1.8,4.854,3.6,9.05,5.192,12.481s3.006,6.079,3.988,7.884l1.183,2.034a4.846,4.846,0,0,0,.439.684,4.749,4.749,0,0,0-.349-.734c-.271-.514-.635-1.2-1.1-2.078-.924-1.832-2.29-4.5-3.822-7.946s-3.29-7.647-5.05-12.5a135.237,135.237,0,0,1-4.977-16.394l-.007.149.8-2.407a6.613,6.613,0,0,0,.14-2.722c-.2-1.779-.576-3.507-.872-5.308-.175-.89-.283-1.8-.466-2.736a5.4,5.4,0,0,0-.464-1.408,1.374,1.374,0,0,0-.628-.632,1.4,1.4,0,0,0-.9-.036l-.191.055a.974.974,0,0,0-.258.147,1.1,1.1,0,0,0-.288.4,2.8,2.8,0,0,0-.19.777,10.1,10.1,0,0,0-.039,1.468c.033.965.125,1.919.207,2.875.047.555.093,1.107.117,1.653a5.356,5.356,0,0,1-.084,1.529c-.028.119-.085.1-.021.155l0,0c-.006-.038.009.058.006.042v-.011a.071.071,0,0,1,0-.039c.006-.01.031-.05.016-.053a.169.169,0,0,1-.068-.063,2.439,2.439,0,0,1-.348-.617,10.46,10.46,0,0,1-.482-1.51,21.464,21.464,0,0,1-.513-3.155c-.127-1.07-.276-2.125-.44-3.169s-.341-2.076-.549-3.1a14.116,14.116,0,0,0-.865-3.039,1.023,1.023,0,0,0-.356-.4,1.768,1.768,0,0,0-.424-.179,1.24,1.24,0,0,0-.961.133,2.13,2.13,0,0,0-.841,1.481,5.391,5.391,0,0,0-.019,1.559c.057.486.1.962.142,1.442a41.248,41.248,0,0,1,.1,5.6,10.118,10.118,0,0,1-.165,1.314,2.934,2.934,0,0,1-.173.589.733.733,0,0,1-.124.213c-.041.094-.077-.022-.074.132.058-.116,0-.051-.042-.149a1.607,1.607,0,0,1-.135-.237,5.694,5.694,0,0,1-.215-.582c-.126-.4-.223-.822-.315-1.237a94.517,94.517,0,0,1-1.285-9.425v.036a4.875,4.875,0,0,0-.185-1.692,1.722,1.722,0,0,0-.445-.758,1.181,1.181,0,0,0-.843-.307l.063.007a.982.982,0,0,0-.981.47,2.44,2.44,0,0,0-.349.884,10.6,10.6,0,0,0-.152,1.709c-.041,1.094-.049,2.124-.018,3.086a40.581,40.581,0,0,0,.628,4.87c.2,1.322.346,2.348.409,3.04a.537.537,0,0,1-.332.595C575.805,158.965,575.712,158.976,575.714,158.989Z",
    transform: "translate(-575.241 -144.228)",
    fill: "#d8b0a3"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M513.317,208.233a24.436,24.436,0,0,0-6.59.755c-5.875,1.546-16.016,7.691-16.436,15.285h7.365s-4.125,8.781-2.912,7.968c3.144-2.11,9.406-8.472,9.406-8.472Z",
    transform: "translate(-490.291 -48.802)",
    fill: "#dec2b8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(121.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M599.152,95.341c-.163.014-.831-6.076-1.494-13.6s-1.066-13.64-.9-13.655.83,6.075,1.493,13.6S599.315,95.326,599.152,95.341Z",
    transform: "translate(-596.72 -68.084)",
    fill: "#635bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(12.032 0.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M630.013,68.411c.134.094-4.843,7.318-11.114,16.132s-11.465,15.884-11.6,15.789,4.843-7.316,11.117-16.132S629.879,68.317,630.013,68.411Z",
    transform: "translate(-607.297 -68.41)",
    fill: "#635bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(22.112 33.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M642.22,97.191c.033.159-5.774,1.489-12.971,2.968s-13.058,2.548-13.091,2.388,5.774-1.489,12.972-2.968S642.187,97.031,642.22,97.191Z",
    transform: "translate(-616.158 -97.175)",
    fill: "#635bff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Folder",
    transform: "translate(184.441 214.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(98.28 38.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M304.46,236.233,264.234,443.046l-5.266,27.074L527.512,468.8c12.052-.059,22.732-10.76,26.61-26.659l47.619-195.253c2.944-12.069-3.515-24.622-12.664-24.613l-271.8.286C311.278,222.562,306.031,228.162,304.46,236.233Z",
    transform: "translate(-258.968 -222.27)",
    fill: "#635bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(98.28 38.718)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M304.46,236.233,264.234,443.046l-5.266,27.074L527.512,468.8c12.052-.059,22.732-10.76,26.61-26.659l47.619-195.253c2.944-12.069-3.515-24.622-12.664-24.613l-271.8.286C311.278,222.562,306.031,228.162,304.46,236.233Z",
    transform: "translate(-258.968 -222.27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M513.639,433.717,485.206,204.6c-1.165-9.387-8.643-16.39-17.472-16.362l-62.348.2A16.99,16.99,0,0,0,393.07,193.9l-29.606,31.47-173.4.906c-10.6.055-18.737,10.081-17.332,21.347l26.4,211.766c1.169,9.374,8.633,16.368,17.451,16.351l302.2-.6c33.658.7,36.87-9.243,36.87-9.243C517.078,474.449,513.642,433.743,513.639,433.717Z",
    transform: "translate(-172.575 -188.235)",
    fill: "#635bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(122.07 126.584)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M368.569,372.258,358.377,383.2l-78.5-70.616,10.192-10.946Z",
    transform: "translate(-279.88 -299.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M353.719,299.509l11.264,10.133-71.026,76.283-11.264-10.133Z",
    transform: "translate(-279.494 -299.509)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble",
    "data-name": "Speech Bubble",
    transform: "translate(532.054 66.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242",
    transform: "translate(27.255 20.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M511.451,107.539a2.123,2.123,0,0,1-1.286-1.861l-.455-10.561a2.123,2.123,0,0,1,2.609-2.157,6.6,6.6,0,0,0,5.136-1.015,5.941,5.941,0,0,0,2.655-3.889,6.081,6.081,0,0,0-1.276-4.569,6.774,6.774,0,0,0-4.483-2.7,7.953,7.953,0,0,0-8.075,5.73,2.122,2.122,0,1,1-4.1-1.113c1.495-5.5,7.172-9.467,12.658-8.836a10.951,10.951,0,0,1,7.383,4.358,10.333,10.333,0,0,1,2.081,7.811,10.193,10.193,0,0,1-4.489,6.737,11.117,11.117,0,0,1-5.757,1.879l.353,8.141a2.125,2.125,0,0,1-2.957,2.043Z",
    transform: "translate(-502.103 -76.504)",
    fill: "#635bff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(8.991 33.731)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M513.474,107.773a1.736,1.736,0,1,1-1.851-1.613A1.737,1.737,0,0,1,513.474,107.773Z",
    transform: "translate(-510.006 -106.155)",
    fill: "#635bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M478.192,95.174a4.386,4.386,0,0,0,.1-.693c.053-.495.127-1.168.223-2.034a23.948,23.948,0,0,1,.549-3.269c.15-.637.228-1.346.461-2.062s.457-1.487.706-2.3a39.115,39.115,0,0,1,5.657-10.838,38.148,38.148,0,0,1,35.264-14.848c.873.083,1.731.316,2.609.469a17.881,17.881,0,0,1,2.618.631,36.135,36.135,0,0,1,10.174,4.612,38.055,38.055,0,0,1,15.037,18.883,37.146,37.146,0,0,1,2.231,12.978,36.482,36.482,0,0,1-2.38,13.358l-.513,1.3-.068.172.069.16c2.854,6.572,5.652,13.016,8.364,19.263l.478-.544c-5.875-2.258-11.57-4.446-17.037-6.546l-.21-.081-.165.159a38.09,38.09,0,0,1-16.089,9.288,37.836,37.836,0,0,1-30.715-4.768,38.977,38.977,0,0,1-9.592-8.931,37.728,37.728,0,0,1-7.277-17.444q-.2-1.665-.358-2.959-.032-1.276-.057-2.174c-.018-.559-.033-1-.043-1.332a2.326,2.326,0,0,0-.038-.453,2.526,2.526,0,0,0-.027.452c0,.333-.01.774-.017,1.336q0,.9,0,2.185.131,1.3.3,2.984a41.46,41.46,0,0,0,1.944,8.034,41.882,41.882,0,0,0,5.216,9.67,39.268,39.268,0,0,0,9.66,9.122,38.312,38.312,0,0,0,31.181,4.978,38.714,38.714,0,0,0,16.412-9.42l-.377.078,17.028,6.573.858.331-.379-.875-8.352-19.267v.332l.526-1.328a37.252,37.252,0,0,0,2.43-13.656A37.938,37.938,0,0,0,552.3,83.441a38.738,38.738,0,0,0-15.369-19.234,36.768,36.768,0,0,0-10.371-4.664,18.485,18.485,0,0,0-2.664-.632c-.893-.152-1.768-.386-2.654-.468a37.475,37.475,0,0,0-23.659,4.625A38.271,38.271,0,0,0,485.552,73.7a38.933,38.933,0,0,0-5.6,11.013q-.358,1.232-.677,2.328c-.224.725-.292,1.441-.43,2.085a22.522,22.522,0,0,0-.48,3.3c-.063.87-.111,1.551-.148,2.048A4.878,4.878,0,0,0,478.192,95.174Z",
    transform: "translate(-478.144 -58.132)",
    fill: "#263238"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomething);
export default __webpack_public_path__ + "static/media/something.8dbc46e5c1b261fb8e06d01e197e4ee1.svg";
export { ForwardRef as ReactComponent };